import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Trusted from "../components/Trusted";
import Pricing from "../components/Pricing";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import TI from "../components/TI";
import FeaturesDept from "../components/FeaturesDept";
import AboutUs from "../components/AboutUs";

export default function Home() {
  return (
    <main className="bg-zentra-bg min-h-screen text-white">
      <Navbar />
      <Hero />
      <Trusted />
      <AboutUs/>
      <FeaturesDept />
      <Pricing />
      <TI />
      <FAQ />
      <Footer />
    </main>
  );
}
